import { api } from 'roadie-ui'
import { WeeklyStatement } from 'types/seattle'
import { PSSTDayRequest } from 'types/seattle'
import { psstResponseToSeattleData } from 'util/seattle'

export async function getSeattleData(profileId: string, weeklyStatements: WeeklyStatement[]) {
  const response = await _getSeattleData(profileId)
  return psstResponseToSeattleData(response.data, weeklyStatements)
}

export async function hasSeattleData(profileId: string) {
  let response = null
  try {
    response = await _getSeattleData(profileId)
  } catch (_) {
    return false
  }

  if (response.rawResponse.status === 204) {
    return false
  }

  return true
}

async function _getSeattleData(profile_id: string) {
  return api.version(3).get(`seattle_sick_days_proxy/${profile_id}/index`)
}

export function spendPSSTDays(profile_id: string, psstDays: PSSTDayRequest[]) {
  return api.version(3).patch(`seattle_sick_days_proxy/${profile_id}/request_to_spend`, undefined, {
    params: { psst_day_requests: JSON.stringify(psstDays) },
    responseType: 'text',
  })
}
